import EventsLoggingService from 'js/EventsLoggingService';
import {nullornot} from 'client/utils/stringsFormatting';
import { getHandlerFor } from 'client/utils/angular';

const DEFAULT_DEVAPP_REPORT = {
  gid: 0,
  radius: 500,
  type_selected: "",
  status: "",
  year_min: 0,
  year_max: 0,
  plu: "",
  tname: "",
  sname: "",
  location: "",
  address: "",
  lat: 0,
  lng: 0,
  zoom: 0,
  username: "",
  myp_municipality: ""
};

export default function ($scope,$location,ngDialog,$rootScope,reportService,$timeout,datorontoService,$window,lockService) {
  $scope.devAppReport = DEFAULT_DEVAPP_REPORT;
  $scope.reportDialog = '';

  $rootScope.isSubmit = false;
  $rootScope.isGenerate = false;
  $rootScope.isProgress = true;
  $rootScope.isLocked = false;
  $rootScope.lockStatus = 1;

  $scope.hasAddress = false;
  if ($rootScope.address != "") {
    $scope.address = $rootScope.address;

    var address = $scope.address.split(',');
    if(address.length >= 3){
      $scope.address = address[0] + ',' + address[1] + ',' + address[address.length-1];
    }

    $scope.hasAddress = true;
  }
  else {
    $scope.address = "Please search an address and select a property before generating a report";
    $scope.hasAddress = false;
  }

  /* Close the report dialog */
  $scope.cancelReport = function () {
    ngDialog.closeAll();
    //$rootScope.$broadcast('openSidebar');
  };

  /* User is requesting additonal reports */
  $scope.requestReports = function(){
    reportService.reportRequest($rootScope.currentUser).success(function (data) {
      ngDialog.closeAll();
      $scope.reportDialog = ngDialog.open({
        templateUrl: '/templates/report-submit.html',
        className: 'ngdialog-theme-default'
      });
    });
  };

  /* User is requesting additonal development reports */
  $scope.requestDevReports = function(){
    reportService.reportDevRequest($rootScope.currentUser).success(function (data) {
      ngDialog.closeAll();
      $scope.reportDialog = ngDialog.open({
        templateUrl: '/templates/report-submit.html',
        className: 'ngdialog-theme-default'
      });
    });
  };

  $scope.getDevReport = function () {
    $rootScope.isChrome = false;
    $rootScope.isFireFox = false;
    $rootScope.isOpera = false;
    $rootScope.isIE = false;
    $rootScope.isSafari = false;

    $rootScope.isSubmit = !$rootScope.isSubmit; //Disable generate button

    $rootScope.isGenerate = !$rootScope.isGenerate;

    /* Variables used for dev report generation */
    $rootScope.amt = 10;
    $rootScope.progressValue = 0;

    $rootScope.countTo = $rootScope.amt;
    $rootScope.countFrom = 0;

    var addr = $scope.devAppReport.address.split(',');

    $scope.devAppReport.address = addr[0];
    $scope.devAppReport.location = $scope.devAppReport.address;
    $scope.devAppReport.username = $rootScope.currentUser.name;
    $scope.devAppReport.gid = $rootScope.propNumber;
    $scope.devAppReport.myp_municipality = $rootScope.myp_municipality;

    reportService.reportDAT($scope.devAppReport).success(function(data){
      $rootScope.IE9 = false;
      $rootScope.isSubmit = !$rootScope.isSubmit;

      var userAgent = navigator.userAgent.toLowerCase();
      // Figure out what browser is being used.
      var Browser = {
        Version: (userAgent.match(/.+(?:rv|it|ra|ie)[\/: ]([\d.]+)/) || [])[1],
        Chrome: /chrome/.test(userAgent),
        Safari: /webkit/.test(userAgent),
        Opera: /opera/.test(userAgent),
        Edge: /edge/.test(userAgent),
        IE: /msie/.test(userAgent) && !/opera/.test(userAgent),
        Mozilla: /mozilla/.test(userAgent) && !/(compatible|webkit)/.test(userAgent),
        Check: function () {
          alert(userAgent);
        }
      };

      //Check if browser is IE 11
      var iCheck = userAgent.search("like gecko");
      if (iCheck > -1) {
        Browser.Mozilla = false;
        Browser.IE = true;
      }

      //Check if browser is IE 10
      var iCheck = userAgent.search("msie 10");
      if (iCheck > -1) {
        Browser.Mozilla = false;
        Browser.IE = true;
      }

      //Check if user is using IE9 or not
      var iCheck = userAgent.search("msie 9.0");
      if(iCheck > -1){
        $rootScope.IE9 = true;
      }else
        $rootScope.IE9 = false;

      if ((Browser.Chrome || Browser.Opera || Browser.Mozilla) && !Browser.Edge) {
        if (Browser.Chrome)
          $rootScope.isChrome = true;
        else if (Browser.Mozilla)
          $rootScope.isFireFox = true;
        else if (Browser.Opera)
          $rootScope.isOpera = true;

        $scope.onTimeout = function () {
          if ($rootScope.amt < 100) {
            $rootScope.amt++;
            $rootScope.countTo = $rootScope.amt;
            $rootScope.progressValue = $rootScope.amt;

            if ($rootScope.amt == 35) {
              $rootScope.amt = 55;
            }

            if ($rootScope.amt == 70) {
              $rootScope.amt = 85;
            }
          }
          if($rootScope.amt == 100){
            $rootScope.isProgress = false;
          }
          $rootScope.mytimeout = $timeout($scope.onTimeout, 200);
        };

        $rootScope.mytimeout = $timeout($scope.onTimeout, 200);

        $scope.oReg = new XMLHttpRequest();

        $scope.oReg.addEventListener("progress", updateProgress, true);
        $scope.oReg.addEventListener("load", transferComplete, false);
        $scope.oReg.addEventListener("error", transferFailed, false);
        $scope.oReg.addEventListener("abort", transferCanceled, false);

        $scope.oReg.onload = function () {
          var a = document.createElement('a');
          a.href = (window.URL || window.webkitURL).createObjectURL($scope.oReg.response); // xhr.response is a blob
          $scope.report_title = $rootScope.report.location;
          while ($scope.report_title.indexOf(",") != -1) {
            $scope.report_title = $scope.report_title.replace(",", " ");
          }
          a.download = $scope.devAppReport.address.replace(/,|-| /g, '_').replace(/\.|'/g, '') + '_' + (new Date().toISOString().split('T')[0].replace(/,|-| /g, '_')) + '.xlsx'; // Set the file name.
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
        };

        $scope.oReg.open("GET", data);
        $scope.oReg.responseType = 'blob';
        $scope.oReg.send();

        //Update report tracking for company
        reportService.devReportUpdate($scope.devAppReport).success(function (data) {

        }).error(function(data){

        });

      } else if (Browser.IE || Browser.Safari || Browser.Edge) {
        if (Browser.IE || Browser.Edge)
          $rootScope.isIE = true;
        else if (Browser.Safari)
          $rootScope.isSafari = true;
        else if (Browser.Mozilla)
          $rootScope.isFireFox = true;

        var iframe = document.createElement("iframe");
        iframe.setAttribute("src", data);
        console.log(data);
        iframe.setAttribute("style", "display: none");
        document.body.appendChild(iframe);

        $scope.onIETimeout = function () {
          if ($rootScope.amt < 100) {
            $rootScope.amt++;
            $rootScope.countTo = $rootScope.amt;
            $rootScope.progressValue = $rootScope.amt;

            if ($rootScope.amt == 35) {
              $rootScope.amt = 55;
            }

            if ($rootScope.amt == 70) {
              $rootScope.amt = 85;
            }
          }
          $rootScope.mytimeout = $timeout($scope.onIETimeout, 500);
        };

        $rootScope.myIEtimeout = $timeout($scope.onIETimeout, 500);

        $timeout(function () {
          $rootScope.amt = 100;
          $rootScope.countTo = $rootScope.amt;
          $rootScope.progressValue = $rootScope.amt;
          $timeout.cancel($rootScope.myIEtimeout);//Stop the progress bar counting.

          $timeout(function () {
            ngDialog.closeAll();
            $scope.reportDialog = ngDialog.open({
              templateUrl: '/templates/report-dev-info.html',
              controller: 'ReportCtrl',
              className: 'ngdialog-theme-default',
              closeByEscape: true,
              closeByDocument: false,
              showClose: false
            });
          }, 1500);
        }, 25000);

        //Update report tracking for company
        reportService.devReportUpdate($scope.devAppReport).success(function (data) {

        }).error(function(data){

        });
      }
      else {
        // Other Browser
      }

      /* functions used for tracking download status */

      // progress on transfers from the server to the client (downloads)
      function updateProgress(oEvent) {
        if (oEvent.lengthComputable) {
          var percentComplete = oEvent.loaded / oEvent.total;
        } else {

        }
      }

      function transferComplete(evt) {
        $timeout(function () {
          $timeout.cancel($rootScope.mytimeout);//Stop the progress bar counting.

          if ($rootScope.amt < 100)//Set the progress bar to 100 if not already 100.
            $rootScope.amt = 100;
          $rootScope.countTo = $rootScope.amt;
          $rootScope.progressValue = $rootScope.amt;

          $timeout(function () {
            ngDialog.closeAll();
            $scope.reportDialog = ngDialog.open({
              templateUrl: '/templates/report-dev-info.html',
              controller: 'ReportCtrl',
              className: 'ngdialog-theme-default',
              closeByEscape: false,
              closeByDocument: false,
              showClose: false
            });
          }, 1000);
        }, 2000);

        //Update report tracking for company
        reportService.devReportUpdate($scope.devAppReport).success(function (data) {

        }).error(function(data){

        });
      }

      function transferFailed(evt) {
        //alert("An error occurred while transferring the file.");
        $scope.reportDialog = ngDialog.open({
          templateUrl: '/templates/report-fail.html',
          controller: 'ReportCtrl',
          className: 'ngdialog-theme-default',
          closeByEscape: false,
          closeByDocument: false,
          showClose: true
        });
        $scope.reportDialog.closePromise.then(function (data) {
          $rootScope.$broadcast('openSidebar');
        });
      }

      function transferCanceled(evt) {
        alert("The transfer has been canceled by the user.");
      }

    }).error(function(data){
      if(data.msg == 'none'){
        ngDialog.closeAll();
        $rootScope.devReportDialog = ngDialog.open({
          templateUrl: '/templates/no-results.html',
          className: 'ngdialog-theme-default'
        });
        $rootScope.devReportDialog.closePromise.then(function (data) {
          //$rootScope.$broadcast('openSidebar');
        });
      }else {
        $rootScope.isSubmit = !$rootScope.isSubmit;
        console.log(data);
        ngDialog.closeAll();
        $scope.reportDialog = ngDialog.open({
          templateUrl: '/templates/report-limit.html',
          controller: 'ReportCtrl',
          className: 'ngdialog-theme-default'
        });
      }
    });
  };

  $scope.getReport = function () {
    EventsLoggingService.clickedGenerateReport();

    /* functions used for tracking download status */
    // progress on transfers from the server to the client (downloads)
    function updateProgress(oEvent) {
      if (oEvent.lengthComputable) {
        var percentComplete = oEvent.loaded / oEvent.total;
      } else {

      }
    }

    function transferComplete(evt) {
      $timeout(function () {
        $timeout.cancel($rootScope.mytimeout);//Stop the progress bar counting.

        if ($rootScope.amt < 100)//Set the progress bar to 100 if not already 100.
          $rootScope.amt = 100;
        $rootScope.countTo = $rootScope.amt;
        $rootScope.progressValue = $rootScope.amt;

        $timeout(function () {
          ngDialog.closeAll();
          $scope.reportDialog = ngDialog.open({
            templateUrl: '/templates/report-info.html',
            controller: 'ReportCtrl',
            className: 'ngdialog-theme-default',
            closeByEscape: true,
            closeByDocument: false,
            showClose: false
          });
        }, 1000);
      }, 2000);

      //Update report tracking for company
      reportService.reportUpdate($rootScope.report).success(function (data) {

      }).error(function (data) {

      });
    };

    function transferFailed(evt) {
      reportService.reportError($rootScope.report).success(function (data) {

      }).error(function (data) {

      });
      //alert("An error occurred while transferring the file.");
      $scope.reportDialog = ngDialog.open({
        templateUrl: '/templates/report-fail.html',
        controller: 'ReportCtrl',
        className: 'ngdialog-theme-default',
        closeByEscape: false,
        closeByDocument: false,
        showClose: true
      });
      $scope.reportDialog.closePromise.then(function (data) {
        $rootScope.$broadcast('openSidebar');
      });
    }

    function transferCanceled(evt) {
      alert("The transfer has been canceled by the user.");
    }
    $rootScope.isChrome = false;
    $rootScope.isFireFox = false;
    $rootScope.isOpera = false;
    $rootScope.isIE = false;
    $rootScope.isSafari = false;

    $rootScope.isSubmit = !$rootScope.isSubmit; //Disable generate button

    $rootScope.isGenerate = !$rootScope.isGenerate;

    $rootScope.amt = 10;
    $rootScope.progressValue = 0;

    $rootScope.countTo = $rootScope.amt;
    $rootScope.countFrom = 0;

    var res = $rootScope.address.split(',');
    $rootScope.address = res[0];

    $rootScope.report.username = $rootScope.currentUser.name;
    $rootScope.report.gid = $rootScope.propNumber;//gid
    $rootScope.report.lat = $rootScope.lat;
    $rootScope.report.lng = $rootScope.lng;
    $rootScope.report.lat2019 = $rootScope.lat2019;
    $rootScope.report.lng2019 = $rootScope.lng2019;
    $rootScope.report.lat4326 = $rootScope.lat4326;
    $rootScope.report.lng4326 = $rootScope.lng4326;
    $rootScope.report.lng2952 = $rootScope.lng2952;
    $rootScope.report.lat2952 = $rootScope.lat2952;
    $rootScope.report.location = $rootScope.address;
    var address = $rootScope.report.location.split(',');

    if(address.length >= 3){
      $rootScope.report.location = address[0] + ',' + address[1] + ',' + address[address.length-1];
    }

    $rootScope.report.myp_area_ha = $rootScope.myp_area_ha;
    $rootScope.report.geomextent = $rootScope.geomextent;
    $rootScope.report.geomextent_width_m = $rootScope.geomextent_width_m;
    $rootScope.report.geomextent_height_m = $rootScope.geomextent_height_m;
    $rootScope.report.myp_municipality = $rootScope.myp_municipality;
    $rootScope.report.department = $rootScope.currentUser.department;
    $rootScope.report.company = $rootScope.currentUser.company;

    var lockStatus = lockService.reportLockStatus();//Get lock status object

    $rootScope.isLocked = !$rootScope.isLocked;//Set UI to show that the user is in queue

    lockStatus.then(function(result){//Call lock status and wait until info is returned
      $rootScope.isLocked = !$rootScope.isLocked;//Set UI to show the user report is generating
      console.log(result);
      $rootScope.lockStatus = result;

      reportService.reportInfo($rootScope.report).success(function (data) {
        console.log(data);
        if(data.msg == 'limit'){
          $rootScope.isSubmit = !$rootScope.isSubmit;
          console.log(data);
          ngDialog.closeAll();
          $scope.reportDialog = ngDialog.open({
            templateUrl: '/templates/report-limit.html',
            controller: 'ReportCtrl',
            className: 'ngdialog-theme-default'
          });
        }else if(data.msg == 'download') {
          $rootScope.IE9 = false;
          $rootScope.isSubmit = !$rootScope.isSubmit;

          $timeout(function () {
            $rootScope.progressValue = $rootScope.amt;
          }, 1000);

          $timeout(function () {
            $rootScope.amt = 20;
            $rootScope.countTo = $rootScope.amt;
            $rootScope.progressValue = $rootScope.amt;
          }, 5000);

          var userAgent = navigator.userAgent.toLowerCase();
          // Figure out what browser is being used.
          var Browser = {
            Version: (userAgent.match(/.+(?:rv|it|ra|ie)[\/: ]([\d.]+)/) || [])[1],
            Chrome: /chrome/.test(userAgent),
            Safari: /webkit/.test(userAgent),
            Opera: /opera/.test(userAgent),
            Edge: /edge/.test(userAgent),
            IE: /msie/.test(userAgent) && !/opera/.test(userAgent),
            Mozilla: /mozilla/.test(userAgent) && !/(compatible|webkit)/.test(userAgent),
            Check: function () {
              alert(userAgent);
            }
          };

          /*
           * navigator.userAgent conflicts with IE because it says that it's Mozilla depending on the
           * version of IE that the user is using.
           * So an additional check MUST be made in order to determine which browser is being used.
           * The conflict is only between Mozilla & IE..
           * For more info see: www.nczonline.net/blog/2013/03/27/internet-explorer-11s-user-agent-string-what-does-it-mean/
           * */

          //Check if browser is IE 11
          var iCheck = userAgent.search("like gecko");
          if (iCheck > -1) {
            Browser.Mozilla = false;
            Browser.IE = true;
          }

          //Check if browser is IE 10
          var iCheck = userAgent.search("msie 10");
          if (iCheck > -1) {
            Browser.Mozilla = false;
            Browser.IE = true;
          }

          //Check if user is using IE9 or not
          var iCheck = userAgent.search("msie 9.0");
          if (iCheck > -1) {
            $rootScope.IE9 = true;
          } else
            $rootScope.IE9 = false;

          var reportGenerateParams = 'username='+ encodeURIComponent($rootScope.report.username) +
            '&system=' + encodeURIComponent($rootScope.report.system) +
            '&gid='+ encodeURIComponent($rootScope.report.gid) +
            '&zoom='+ encodeURIComponent($rootScope.report.zoom) +
            '&location='+ encodeURIComponent($rootScope.report.location) +
            '&myp_municipality='+ encodeURIComponent($rootScope.report.myp_municipality) +
            '&myp_area_ha='+ encodeURIComponent($rootScope.report.myp_area_ha) +
            '&geomextent='+ encodeURIComponent(JSON.stringify($rootScope.report.geomextent)) +
            '&geomextent_width_m='+ encodeURIComponent($rootScope.report.geomextent_width_m) +
            '&geomextent_height_m='+ encodeURIComponent($rootScope.report.geomextent_height_m) +
            '&lng='+ encodeURIComponent($rootScope.report.lng) +
            '&lat='+ encodeURIComponent($rootScope.report.lat) +
            '&lng2019='+ encodeURIComponent($rootScope.report.lng2019) +
            '&lat2019='+ encodeURIComponent($rootScope.report.lat2019) +
            '&lng4326=' + encodeURIComponent($rootScope.report.lng4326) +
            '&lat4326=' + encodeURIComponent($rootScope.report.lat4326);

          if ((Browser.Chrome || Browser.Opera || Browser.Mozilla) && !Browser.Edge) {
            if (Browser.Chrome)
              $rootScope.isChrome = true;
            else if (Browser.Mozilla)
              $rootScope.isFireFox = true;
            else if (Browser.Opera)
              $rootScope.isOpera = true;

            $scope.onTimeout = function () {
              if ($rootScope.amt < 100) {
                $rootScope.amt++;
                $rootScope.countTo = $rootScope.amt;
                $rootScope.progressValue = $rootScope.amt;

                if ($rootScope.amt == 35) {
                  $rootScope.amt = 55;
                }

                if ($rootScope.amt == 70) {
                  $rootScope.amt = 85;
                }
              }
              if ($rootScope.amt == 100) {
                $rootScope.isProgress = false;
              }
              $rootScope.mytimeout = $timeout($scope.onTimeout, 700);
            };

            $rootScope.mytimeout = $timeout($scope.onTimeout, 700);

            $scope.oReg = new XMLHttpRequest();

            $scope.oReg.addEventListener("progress", updateProgress, true);
            $scope.oReg.addEventListener("load", transferComplete, false);
            $scope.oReg.addEventListener("error", transferFailed, false);
            $scope.oReg.addEventListener("abort", transferCanceled, false);

            $scope.oReg.onload = function () {
              var a = document.createElement('a');
              a.href = (window.URL || window.webkitURL).createObjectURL($scope.oReg.response); // xhr.response is a blob
              $scope.report_title = $rootScope.report.location;
              while ($scope.report_title.indexOf(",") != -1) {
                $scope.report_title = $scope.report_title.replace(",", " ");
              }

              a.download = $rootScope.report.location.replace(/,|-| /g, '_').replace(/\.|'/g, '') + '_' + (new Date().toISOString().split('T')[0].replace(/,|-| /g, '_')) + '.docx';

              a.style.display = 'none';
              document.body.appendChild(a);
              a.click();
            };

            $scope.oReg.open('POST', '/users/report_generate', true);
            $scope.oReg.responseType = 'blob';
            $scope.oReg.setRequestHeader("Content-type", "application/x-www-form-urlencoded");//Send the proper header information along with the request
            $scope.oReg.send(reportGenerateParams);

            /* var a = document.createElement('a');
             a.href = '/report_test';
             a.download = 'Test_Report.docx';
             a.style.display = 'none';
             document.body.appendChild(a);
             a.click(); */
          } else if (Browser.IE || Browser.Safari || Browser.Edge) {
            if (Browser.IE || Browser.Edge)
              $rootScope.isIE = true;
            else if (Browser.Safari)
              $rootScope.isSafari = true;
            else if (Browser.Mozilla)
              $rootScope.isFireFox = true;

            var iframe = document.createElement("iframe");
            iframe.setAttribute("src", "/users/report_generate?"+reportGenerateParams);
            console.log(data);
            iframe.setAttribute("style", "display: none");
            document.body.appendChild(iframe);

            $scope.onIETimeout = function () {
              if ($rootScope.amt < 100) {
                $rootScope.amt++;
                $rootScope.countTo = $rootScope.amt;
                $rootScope.progressValue = $rootScope.amt;

                if ($rootScope.amt == 35) {
                  $rootScope.amt = 55;
                }

                if ($rootScope.amt == 70) {
                  $rootScope.amt = 85;
                }
              }
              $rootScope.mytimeout = $timeout($scope.onIETimeout, 500);
            };

            $rootScope.myIEtimeout = $timeout($scope.onIETimeout, 500);

            $timeout(function () {
              $rootScope.amt = 100;
              $rootScope.countTo = $rootScope.amt;
              $rootScope.progressValue = $rootScope.amt;
              $timeout.cancel($rootScope.myIEtimeout);//Stop the progress bar counting.

              $timeout(function () {
                ngDialog.closeAll();
                $scope.reportDialog = ngDialog.open({
                  templateUrl: '/templates/report-info.html',
                  controller: 'ReportCtrl',
                  className: 'ngdialog-theme-default',
                  closeByEscape: false,
                  closeByDocument: false,
                  showClose: false
                });
              }, 1500);
            }, 25000);

            //Update report tracking for company
            reportService.reportUpdate($rootScope.report).success(function (data) {

            }).error(function (data) {

            });
          }
          else {
            // Other Browser
          }
        }

      }).error(function(data){
        $rootScope.isSubmit = !$rootScope.isSubmit;
        console.log(data);
        ngDialog.closeAll();
        $scope.reportDialog = ngDialog.open({
          templateUrl: '/templates/report-limit.html',
          controller: 'ReportCtrl',
          className: 'ngdialog-theme-default'
        });
      });
    });


  };

  $scope.todaysDate = function(){
    //Collection of variables to get todays date
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth()+1;
    var yyyy = today.getFullYear();

    if(dd < 10){
      dd = '0' + dd;
    }

    if(mm < 10){
      mm = '0' + mm;
    }

    today = mm+'_'+dd+'_'+yyyy;
    return today;
  };

  $scope.openReport = () => {
    EventsLoggingService.clickedMakeAReport();

    $rootScope.userPath = $location.path();

    $scope.reportDialog = ngDialog.open({
      templateUrl:'/templates/report-console.html',
      controller:'ReportCtrl',
      className: 'ngdialog-theme-default',
      closeByEscape: true,
      closeByDocument: false,
      showClose: false
    });
    $scope.reportDialog.closePromise.then(function (data) {
      $location.path($rootScope.userPath);
    });
  };

  const updateReportCoordinates = (lat, lng) => {
    $scope.devAppReport.lat = lat;
    $scope.devAppReport.lng = lng;
  };

  const updateReportLocation = (devAddress) => {
    $scope.devAppReport.location = devAddress;
  };

  const updateReportGidAndAddress = (propertyInfo) => {
    const {gid,location,myp_municipality, myp_area_ha} = propertyInfo;

    const address = nullornot(location) + ', ' + myp_municipality;

    $scope.devAppReport = Object.assign($scope.devAppReport, {
      address,
      gid: nullornot(gid),
      myp_municipality
    });
  };

  const updateReportFilter = (devAppFilter) => {
    const {radius, status, type_selected, year_min, year_max, plu} = devAppFilter;

    $scope.devAppReport = Object.assign($scope.devAppReport, {
      radius,
      status,
      type_selected,
      year_min,
      year_max,
      plu
    });

    $scope.devAppReport.tname = devAppFilter.type_selected;
    $scope.devAppReport.sname = devAppFilter.status;
  };

  const zoom = (zoom) => {
    $scope.devAppReport.zoom = $rootScope.report.zoom;
  };

  const checkCount = () => {
    datorontoService.devappCount($scope.devAppReport).success(function (data){
      if(data == 'none')
        $rootScope.$broadcast('devmessage');
    });
  };

  $rootScope.$on('sidebar/report/zoom', getHandlerFor(zoom));
  $rootScope.$on('sidebar/report/updatereportcoordinates', getHandlerFor(updateReportCoordinates));
  $rootScope.$on('sidebar/report/updatereportgidandaddress', getHandlerFor(updateReportGidAndAddress));
  $rootScope.$on('sidebar/report/updatereportfilter', getHandlerFor(updateReportFilter));
  $rootScope.$on('sidebar/report/openreport', getHandlerFor($scope.openReport));
  $rootScope.$on('sidebar/report/checkcount', getHandlerFor(checkCount));

  $rootScope.$on('sidebar/report/devaddressupdated', getHandlerFor(updateReportLocation));

  return {
    updateReportCoordinates,
    zoom
  };
};



// WEBPACK FOOTER //
// ./client/controllers/Report.js